<div class="container">
    <div class="content top-margin">


        <div class="container">
            <div class="row">

                <!-- Left side menu -->
                <!-- end left side menu -->
                <div class="col-md-1"></div>
                <div class="col-md-10">

                    <!-- Form Panel -->
                    <div class="card contact-help">
                        <div class="panel-heading">
                            <h3 class="card-title fw-bold">YOUR REQUEST HAS BEEN SUBMITTED SUCCESSFULLY</h3>
                        </div>
                        <div class="card-body">
                            One of our NBCU Help Desk Technicians will follow up with you shortly. If this is urgent
                            please call our support line at 1-855-NBCU-TECH.

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
